<template>
  <div class="choose_sys_user">
    <el-dialog
      v-if="visible"
      show-close
      :visible="visible"
      :width="width"
      :title="defauleTitle || title"
      :close-on-click-modal="false"
      :before-close="close"
      :modal-append-to-body="false"
      :modal="true"
    >
      <Main
        ref="main"
        :multiple="multiple"
        :reserve="reserve"
        :checkedCount="checkedCount"
        :highlight="highlight"
        :tableHeight="tableHeight"
        @chooseChange="chooseChange"
      />
      <span slot="footer" class="flex justify-end mt-20px mb-10px">
        <el-button @click="close" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          class="ml-2"
          @click="confirm"
          :disabled="!checkedCount"
          size="small"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './Main.vue'

export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    width: { type: String, default: '90%' },
    confirmOnClose: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: true },
    highlight: { type: Boolean, default: true },
    tableHeight: { type: Number, default: 500 },
  },
  data() {
    return {
      defauleTitle: this.$l('INDEX.dialog_choose_user_title') || '选择人员',
      checkedRow: null,
    }
  },
  computed: {
    checkedCount() {
      if (this.multiple) {
        return !this.checkedRow ? 0 : this.checkedRow.length
      }
      return this.checkedRow ? 1 : 0
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
      this.checkedRow = null
    },
    confirm() {
      if (!this.checkedCount) return
      this.$emit('confirm', this.checkedRow)
      if (this.confirmOnClose) this.close()
    },
    chooseChange(data) {
      this.checkedRow = data
    },
  },
}
</script>

<style lang="scss" scoped></style>
